import React, { Component } from 'react';
import styled from 'styled-components';
import logo from '../images/logo.png';
import NavbarItemList from './navbar.itemlist.component';
import NavbarItem from './navbar.item.component';
import '../css/navbar.css';

const Div = styled.div`
    padding-top:75px;
`;

class NavBar extends Component {
	constructor(props) {
  		super(props);
  		this.state = {
              smallMenuOpen : false
  		};
      }
    
    menuClickHandler(isMenuOpen = null) {
        if((isMenuOpen != null && isMenuOpen) || (isMenuOpen === null && !this.state.smallMenuOpen)) {
            document.getElementById('menuSmallScreens').classList.remove('fadeOut');
            document.getElementById('menuSmallScreens').classList.add('fadeIn');
            this.setState({
                smallMenuOpen: true
            });
        }
        else {
            document.getElementById('menuSmallScreens').classList.add('fadeOut');            
            this.setState({
                smallMenuOpen: false
            });
        }
    }
      
	render() {
    	return (
            <div>
                <nav className="navbar navbar-expand-lg navbar-light bg-light opacity90">

                        <div className="d-xxl-inline text-center">
                            <a className="navbar-brand" href="/">
                                <img src={logo} className="img-fluid logo" alt="Logo" />
                                <span> </span>
                                <span className="logoTitle">KiTa Bongartzstift Förderverein</span>
                                <span> </span>
                                <img src={logo} className="img-fluid logo" alt="Logo" />
                            </a>
                        </div>
                        <div className="d-xs-inline d-xxl-none">
                            <div className="row">
                                <div className="col-12">
                                    <a className="navbar-brand" href="/">
                                        <img src={logo} className="img-fluid logo" alt="Logo" />
                                    </a>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 logoTitle">
                                    KiTa Bongartzstift Förderverein
                                </div>
                            </div>
                        </div>
                        <button className="navbar-toggler" type="button" onClick={this.menuClickHandler.bind(this)}>
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <NavbarItemList key="navbarItemList" handleClickEvent={this.menuClickHandler.bind(this)} />
                        </div>
                </nav>

                <div id="menuSmallScreens" className="menu opacity90 bg-light d-lg-none">
                    <NavbarItemList key="navbarItemListSmallScreens" handleClickEvent={this.menuClickHandler.bind(this)} />
                    <Div>
                        <ul className="navbar-nav mr-auto">
                            <NavbarItem key="navMenuItemImpressumSmallScreens" handleClickEvent={this.menuClickHandler.bind(this)} name="Impressum" url="impressum" />
                            <NavbarItem key="navMenuItemDatenschutzSmallScreens" handleClickEvent={this.menuClickHandler.bind(this)} name="Datenschutz" url="datenschutz" />
                        </ul>
                    </Div>
                </div>
            </div>
    	);
  	}
}

export default NavBar;


// WEBPACK FOOTER //
// ./src/components/navbar.component.js